import React from 'react';
import PropTypes from 'prop-types';

/**
 * White card shell with a light grey title header strip. Reusable wrapper
 * for "add/edit X" forms outside the companies containers - pairs with the
 * form-card__* classes in scss/component/form-card.scss.
 */
const FormCard = ({ title, actions, children, className, bodyClassName }) => (
  <div className={`form-card${className ? ` ${className}` : ''}`}>
    {(title || actions) && (
      <div className="form-card__header">
        {title && <span className="form-card__title">{title}</span>}
        {actions && <div className="form-card__header-actions">{actions}</div>}
      </div>
    )}
    <div
      className={`form-card__body${bodyClassName ? ` ${bodyClassName}` : ''}`}
    >
      {children}
    </div>
  </div>
);

FormCard.propTypes = {
  title: PropTypes.node,
  actions: PropTypes.node,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  bodyClassName: PropTypes.string,
};

FormCard.defaultProps = {
  title: undefined,
  actions: undefined,
  className: '',
  bodyClassName: '',
};

export default FormCard;
